<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `transaction/assign-schedule/${inputs.id}`
						: `transaction/assign-schedule`
				"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_placement_id" class="col-sm-3 mb-0">
						Placement ID
					</label>
					<app-input
						id="inputs_placement_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_placement_id"
						@input="setPlacementIdValue"
						:fetch-url="`/transaction/placement?clc_id_number=${inputs.clc_id_number}`"
						placeholder="Placement ID"
						list-value-field="placement_id_for_assign_schedule"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_product_name" class="col-sm-3 mb-0">
						Product Name
					</label>
					<!-- <app-input
						id="inputs_product_name"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.product_id"
						:list="productIdLists"
						placeholder="Product Name"
						:disabled="productIDDisabled"
					/> -->
					<app-input
						id="inputs_product_name"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						fetch-url="/master/product?is_active=true&product_category_exclude=3,2&per_page=50"
						v-model="input_product_id"
						placeholder="Product Name"
						@input="setProductID"
						list-value-field="name"
						:disabled="productIDDisabled"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_recommended_by" class="col-sm-3 mb-0">
						Recommended By
					</label>
					<app-input
						id="inputs_recommended_by"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						fetch-url="/user-list"
						v-model="input_recommended_by"
						placeholder="Recommended By"
						@input="setRecommendedByValue"
            			list-value-field="full_name"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label
						for="inputs_assign_schedule_date"
						class="col-sm-3 mb-0"
					>
						Date
					</label>
					<app-input
						id="inputs_assign_schedule_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.assign_schedule_date"
						placeholder="Date"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_note" class="col-sm-3 mb-0">
						Note
					</label>
					<app-input
						id="inputs_note"
						class="col-sm-9"
						type="textarea"
						v-model="inputs.note"
						placeholder="Note"
					/>
				</div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
				<div class="form-group row align-items-center"></div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";
import { UserMixin } from "../../../../../Auth/Mixins/UserMixin";

export default {
	name: "AssignScheduleTableForm",
	mixins: [FormMixin, ModalMixin, UserMixin],
	props: {
		tableId: String,
		formId: String,
		clcIdNumber: String,
		value: {
			type: Object,
			default: () => {
				return {
					name: "",
				};
			},
		},
	},
	data() {
		return {
			productIDDisabled: false,
			preloader: false,
			inputs: {
				clc_id_number: this.clcIdNumber,
			},
			phone: "",
			placementIdLists: [],
			assignedByLists: [],
			recommendedByLists: [],
			productIdLists: [],
			modalId: this.formId,
			modalTitle: this.$t("add"),
			statusLists: [
				{ id: 1, value: "Active" },
				{ id: 2, value: "Inactive" },
				{ id: 3, value: "Invite" },
			],
			subStatusLists: [
				{ id: 1, value: "Active" },
				{ id: 2, value: "Inactive" },
				{ id: 3, value: "Invite" },
			],
			input_recommended_by: {},
			input_placement_id: {},
			input_product_id:{}
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		} else {
			this.inputs.recommended_by = this.user.loggedInUser.id;
		}

		this.fetchData();
	},
	methods: {
		async fetchData() {
			try {
				let [placementIdResponse, userResponse, productIdResponse] =
					await Promise.all([
						axios.get("/transaction/placement?per_page=50"),
						axios.get("/user-list"),
						axios.get(
							"/master/product?is_active=true&product_category_exclude=3,2&per_page=50"
						),
					]);

				placementIdResponse.data.data.forEach((item) => {
					this.placementIdLists.push({
						id: item.id,
						value: item.placement_id_for_assign_schedule,
					});
				});

				userResponse.data.data.forEach((item) => {
					this.assignedByLists.push({
						id: item.id,
						value: item.full_name
							? item.full_name
							: item.first_name + " " + item.last_name,
					});
					this.recommendedByLists.push({
						id: item.id,
						value: item.full_name
							? item.full_name
							: item.first_name + " " + item.last_name,
					});
				});

				productIdResponse.data.data.forEach((item) => {
					this.productIdLists.push({
						id: item.id,
						name: item.name,
					});
				});

				let recommendedBy = {
					id: this.user.loggedInUser.id,
					full_name: this.user.loggedInUser.full_name,
				};

				this.setRecommendedByValue(recommendedBy);

				this.$set(this, 'productIDDisabled', this.input_placement_id?.id ? true : false);

			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		submit() {
			this.inputs.assign_schedule_date = this.formattedDate(
				this.inputs.assign_schedule_date
			);

			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			try {
				this.inputs.id = response.data.id;
				this.input_placement_id = response.data.placement_id ?? null;
				this.inputs.placement_id = response.data.placement_id.id;
				this.inputs.product_id = response.data.product_id.id;

				this.inputs.assign_schedule_date =
					response.data.assign_schedule_date;
				this.inputs.note = response.data.note;

				let placementId = {
					id: response.data.placement_id,
					placement_id_for_assign_schedule: response.data.placement?.placement_id_for_assign_schedule,
					product: response.data.product_id
				}

				this.setPlacementIdValue(placementId);

				let recommendedBy = {
					id: this.user.loggedInUser.id,
					full_name: this.user.loggedInUser.full_name,
				};

				if (response.data.recommended_by?.id) {
					recommendedBy = {
						id: response.data.recommended_by.id,
						full_name: response.data.recommended_by.full_name,
					};
				}
				
				this.$set(this, 'productIDDisabled', true);

      			this.setRecommendedByValue(recommendedBy);

				this.preloader = false;
			} catch (error) {
				// Handle any potential errors
				console.error(
					"Error occurred while processing response data:",
					error
				);
				// Set inputs to default values or handle the error appropriately
				this.inputs.placement_id = null;
				this.inputs.product_id = null;
				this.inputs.recommended_by = null;
				this.preloader = false;
			}
		},

		setPlacementIdValue(data) {
			if (data && data.hasOwnProperty("id")) {
				this.$set(this.inputs, 'placement_id', data.id);

				let product = {
					id: data.product?.id,
					name: data.product?.name
				}
				
				this.setProductID(product);

				// this.inputs.product_id = data.product?.id;
			}

			this.$set(this, 'input_placement_id', data);
		},

		setRecommendedByValue(data) {
			if (data && data.hasOwnProperty("id")) {
				this.$set(this.inputs, "recommended_by", data.id);
			}

			this.$set(this, "input_recommended_by", data);
		},

		setProductID(data) {
			if (data && data.hasOwnProperty("id")) {
				this.$set(this.inputs, "product_id", data.id);
			}

			this.$set(this, "input_product_id", data);
		},

		formattedDate(payloadDate) {
			const originalDate = payloadDate;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day}`;

			return formattedDate;
		},
	},
};
</script>
